// 단일 색상 제목의 무색 문장부호가 제목 색상을 상속하도록 보정한다.
export function normalizeHeadingColors(root) {
  root.querySelectorAll("h1,h2,h3,h4,h5").forEach(heading => {
    if (heading.style.color) return;
    const colors = new Set();
    let hasUncoloredLetters = false;
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const text = walker.currentNode;
      if (!text.textContent.trim()) continue;
      let element = text.parentElement;
      while (element !== heading && !element.style.color) element = element.parentElement;
      if (element.style.color) colors.add(element.style.color);
      else if (!/^[\p{P}\p{Z}\s]+$/u.test(text.textContent)) hasUncoloredLetters = true;
    }
    if (colors.size === 1 && !hasUncoloredLetters) heading.style.color = [...colors][0];
  });
}
